import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Users } from "lucide-react";

export default function Connections() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/connections").then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, []);

  return (
    <div className="flex-1 flex flex-col p-6 grain">
      <header className="pt-8">
        <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground">Kept</p>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl tracking-tight">People you chose to keep.</h1>
        <p className="mt-3 text-muted-foreground">Both of you said yes. That's how they made it here.</p>
      </header>

      <section className="mt-10 flex-1">
        {rows === null && (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} /> Loading…
          </div>
        )}

        {rows && rows.length === 0 && (
          <div className="pt-8 text-center animate-fade-in" data-testid="connections-empty">
            <Users className="h-8 w-8 text-secondary/60 mx-auto mb-4" strokeWidth={1.2} />
            <p className="font-serif italic text-lg text-foreground/70 max-w-xs mx-auto">
              No one yet. Keep showing up — the right person will.
            </p>
          </div>
        )}

        {rows && rows.length > 0 && (
          <ul className="divide-y divide-border/70" data-testid="connections-list">
            {rows.map((c) => (
              <li key={c.id} className="py-5" data-testid={`connection-${c.id}`}>
                <div className="flex items-baseline justify-between gap-3">
                  <p className="font-serif text-xl">{c.user.name}</p>
                  <p className="text-[11px] tracking-wide uppercase text-muted-foreground">
                    {new Date(c.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                  </p>
                </div>
                <p className="text-sm text-muted-foreground mt-1">
                  {c.language} · {c.user.email}
                </p>
                {c.user.bio ? <p className="mt-2 text-sm italic text-foreground/70">"{c.user.bio}"</p> : null}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
